import { render, staticRenderFns } from "./AcademyCalendar.vue?vue&type=template&id=735b208b&scoped=true"
import script from "./AcademyCalendar.vue?vue&type=script&lang=js"
export * from "./AcademyCalendar.vue?vue&type=script&lang=js"
import style0 from "./AcademyCalendar.vue?vue&type=style&index=0&id=735b208b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b208b",
  null
  
)

export default component.exports